// Shared utility for formatting billing intervals consistently

export const formatBillingInterval = (item: any): string => {
  // Helper function to format interval based on interval and count
  const formatInterval = (interval: string, count: number) => {
    let result = ''
    if (count > 1) {
      if (interval === 'month' && count === 3) {
        result = 'quarterly'
      } else if (interval === 'month' && count === 6) {
        result = 'semi-annually'
      } else if (interval === 'year' && count === 1) {
        result = 'yearly'
      } else {
        result = `${count} ${interval}${count > 1 ? 's' : ''}`
      }
    } else {
      result = interval
    }
    return result
  }

  // Check if it's a one-time payment first
  if (
    item.priceDetails?.type === 'one_time' ||
    item.price?.type === 'one_time'
  ) {
    return 'one-time'
  }

  // First try to get from the price object (most reliable)
  if (item.priceDetails?.recurring?.interval) {
    const { interval, interval_count: count } = item.priceDetails.recurring
    return formatInterval(interval, count)
  }

  // Check if item has a price object (used in invoice preview)
  if (item.price?.recurring?.interval) {
    const { interval, interval_count: count } = item.price.recurring
    return formatInterval(interval, count)
  }

  // Fallback to subscription item data
  if (item.billing_interval) {
    const { billing_interval: interval, billing_interval_count: count } = item
    return formatInterval(interval, count)
  }

  // If not available in priceDetails, try to find in available_prices
  const priceFromAvailable = item.available_prices?.find(
    (price: any) => price.id === item.price_id
  )
  if (priceFromAvailable?.recurring?.interval) {
    const { interval, interval_count: count } = priceFromAvailable.recurring
    return formatInterval(interval, count)
  }

  // Check if available_prices has one-time type
  if (priceFromAvailable?.type === 'one_time') {
    return 'one-time'
  }

  return 'monthly' // Default fallback
}
